import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { content } from "../data/content";
import type { Metadata } from "next";

// Utility function for merging Tailwind classes
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

// Metadata construction options
export interface MetadataOptions {
  title?: string;
  description?: string;
  image?: string;
  icons?: string;
  noIndex?: boolean;
}

// Construct Next.js metadata object
export function constructMetadata({
  title = content.metadata.title,
  description = content.metadata.description,
  image = content.metadata.thumbnail,
  icons = content.metadata.icon,
  noIndex = false
}: MetadataOptions = {}): Metadata {
  return {
    title,
    description,
    openGraph: {
      title,
      description,
      images: [
        {
          url: image
        }
      ]
    },
    twitter: {
      card: "summary_large_image",
      title,
      description,
      images: [image]
    },
    icons,
    metadataBase: new URL(content.metadata.url),
    ...(noIndex && {
      robots: {
        index: false,
        follow: false
      }
    })
  };
}

